import "./FrequentlyAskedQuestionsAboutCustomWatchesLowMOQ.module.css";
import Header from "@/reusable_sections/Header";
import BusinessesOverviewHero from "./sections/BusinessesOverviewHero";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import SupportUs from "./sections/SupportUs";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function FrequentlyAskedQuestionsAboutCustomWatchesLowMOQPage() {
  return <div>
      <Header />
      <BusinessesOverviewHero />
      <FrequentlyAskedQuestions />
      <SupportUs />
      <CallToAction />
      <Footer />
    </div>;
}